import { AfterViewInit, ChangeDetectorRef, Component, HostListener } from '@angular/core'
import { Title, Meta } from '@angular/platform-browser'

@Component({
  selector: 'app-benefits',
  templateUrl: 'benefits.component.html',
  styleUrls: ['benefits.component.css'],
})
export class BenefitsComponent implements AfterViewInit {
  
  heartalt: string = 'HeartI3346'
  heartsrc: string = '/assets/external/heart-icon-black.svg'
  dropdownalt: string = 'DropdownI3346'
  dropdownsrc: string = '/assets/external/dropdown3133-g7cc.svg'
  dropdownUpsrc: string = '/assets/external/arriba.svg'
  accordionsState: boolean[] = [false, false, false, false]; 


  screenWidth: number;
  constructor(private cdr: ChangeDetectorRef) {
    this.getScreenSize();
  }
  ngAfterViewInit(): void {
  }

  @HostListener('window:resize', ['$event'])
  getScreenSize(event?) {
    setTimeout(() => {
      this.screenWidth = screen.width;
      this.cdr.detectChanges();
    });
  }

  clicItem(index: number) {
    this.accordionsState[index] = !this.accordionsState[index];
  }

  getImageSrc(index: number): string {
    return this.accordionsState[index] ? this.dropdownUpsrc : this.dropdownsrc;
  }

  downloadBrochure(): void {

    const url: string = window.location.origin + "/assets/docs/brochure_blue_assist.pdf";

    console.log('downloading brochure from: ', url);

    let link = document.createElement('a');
    link.setAttribute('type', 'hidden');
    link.href = url;
    link.download = url;
    document.body.appendChild(link);
    link.click();
    link.remove();
  }
}
